module.exports = __webpack_public_path__ + "img/ikinci-el-arac-garanti-sigortasi.f5132db7.svg";